export const ACCESS_TOKEN_SESSION_KEY = "access_token";
export const ID_TOKEN_SESSION_KEY = "id_token";
export const REFRESH_TOKEN_SESSION_KEY = "refresh_token";
export const COGNITO_CLIENT_ID = "3fg00vaetfs9qiah06h6ougpv2";
export const LOGIN_URL = `https://login.bourland.link/oauth2/authorize?response_type=code&client_id=${COGNITO_CLIENT_ID}&redirect_uri=${window.location.origin}`;
export const LOGOUT_URL = `https://login.bourland.link/logout?client_id=${COGNITO_CLIENT_ID}&logout_uri=${window.location.origin}&redirect_uri=${window.location.origin}`;
